// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  height: 3.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.navbar__start-section {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 0.75rem;
  margin: 0 0 0 1.5rem;
}
.navbar__end-section {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 0.5rem;
  margin: 0 1rem 0 0;
}
.navbar__end-section ion-button {
  margin: 0;
}
.navbar__end-section app-rglogo::ng-deep img {
  display: block;
}

.navbar__time-section {
  height: 1.188rem;
  margin: 2px 1rem;
  margin-left: max(1.5rem, env(safe-area-inset-left));
  margin-right: max(1.5rem, env(safe-area-inset-right));
  display: flex;
  display: flex;
  align-items: center;
}

navbar-state-selector {
  margin-left: auto;
}

ion-menu-button {
  height: 100%;
  --background-hover-opacity: 0;
}
ion-menu-button:has(ion-icon[name*=menu-sharp]) {
  margin-top: 0.25rem;
  --padding-start: 0;
  --padding-end: 0;
  width: 1.5rem;
}
ion-menu-button:has(ion-icon[name*=person-outline]) {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--ion-color-secondary);
  border-radius: 50%;
}

ion-icon[name*=menu-sharp] {
  font-size: 1.5rem;
}

ion-icon[name*=person-outline] {
  font-size: 1.25rem;
}

.header-md::after,
.header-ios::after {
  content: "";
  height: 0;
}

@media screen and (max-width: 768px) {
  .navbar__start-section {
    flex: 1;
    justify-content: flex-start;
  }
}
@media screen and (max-width: 576px) {
  .navbar {
    height: 2.75rem;
  }
  .navbar__start-section {
    margin-left: 0.5rem;
    gap: 0.5rem;
  }
  .navbar__end-section {
    gap: 0.5rem;
    margin: 0 0.5rem 0 0;
  }
  .navbar__end-section:has(app-navbar-deposit) {
    margin-bottom: 0.25rem;
  }
  .navbar__end-section app-rglogo::ng-deep img {
    width: 2rem;
    height: 2rem;
  }
  .navbar__end-section app-navbar-deposit::ng-deep ion-button {
    margin: 0;
    height: 2rem;
    min-height: 2rem;
  }
  .navbar ion-menu-button:has(ion-icon[name*=person-outline]) {
    width: 2.5rem;
  }
  .navbar__time-section pre {
    margin: 2px 0.5rem;
    margin-left: max(0.5rem, env(safe-area-inset-left));
  }
}
@media screen and (max-width: 400px) {
  .navbar--cobrand .navbar__start-section {
    gap: 0.25rem;
  }
  .navbar--cobrand .navbar__end-section {
    gap: 0.25rem;
  }
}
@media screen and (max-width: 370px) {
  app-rglogo::ng-deep img {
    width: 1.5rem;
    height: 1.5rem;
  }
  ion-button[name*=navbar] {
    width: 3.75rem;
    font-size: 0.8rem;
  }
  .navbar ion-menu-button:has(ion-icon[name*=custom-person]) {
    width: 2rem;
  }
}
@media screen and (max-width: 330px) {
  .navbar ion-menu-button:has(ion-icon[name*=custom-person]) {
    width: 1.8rem;
  }
}
.safe-area-left-padding {
  padding-left: env(safe-area-inset-left);
}

ion-icon[name=custom-person] {
  font-size: 2.25rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AACR;AAEI;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAAR;AAEQ;EACI,SAAA;AAAZ;AAIY;EACI,cAAA;AAFhB;;AAQA;EACI,gBAAA;EACA,gBAAA;EACA,mDAAA;EACA,qDAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AALJ;;AAQA;EACI,iBAAA;AALJ;;AAQA;EACI,YAAA;EAmBA,6BAAA;AAvBJ;AAMI;EACI,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAJR;AAOI;EACI,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;AALR;;AAWA;EACI,iBAAA;AARJ;;AAWA;EACI,kBAAA;AARJ;;AAWA;;EAEI,WAAA;EACA,SAAA;AARJ;;AAWA;EAEQ;IACI,OAAA;IACA,2BAAA;EATV;AACF;AAaA;EACI;IACI,eAAA;EAXN;EAaM;IACI,mBAAA;IACA,WAAA;EAXV;EAcM;IACI,WAAA;IACA,oBAAA;EAZV;EAcU;IACI,sBAAA;EAZd;EAgBc;IACI,WAAA;IACA,YAAA;EAdlB;EAmBc;IACI,SAAA;IACA,YAAA;IACA,gBAAA;EAjBlB;EAuBU;IACI,aAAA;EArBd;EA2BM;IACI,kBAAA;IACA,mDAAA;EAzBV;AACF;AA6BA;EAGY;IACI,YAAA;EA7Bd;EAgCU;IACI,YAAA;EA9Bd;AACF;AAmCA;EAEQ;IACI,aAAA;IACA,cAAA;EAlCV;EAsCE;IACI,cAAA;IACA,iBAAA;EApCN;EAyCU;IACI,WAAA;EAvCd;AACF;AA4CA;EAGY;IACI,aAAA;EA5Cd;AACF;AAiDA;EACI,uCAAA;AA/CJ;;AAkDA;EACI,kBAAA;AA/CJ","sourcesContent":[".navbar {\n    height: 3.75rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    &__start-section {\n        display: flex;\n        justify-content: space-evenly;\n        align-items: center;\n        gap: 0.75rem;\n        margin: 0 0 0 1.5rem;\n    }\n\n    &__end-section {\n        display: flex;\n        justify-content: space-evenly;\n        align-items: center;\n        gap: 0.5rem;\n        margin: 0 1rem 0 0;\n\n        ion-button {\n            margin: 0;\n        }\n\n        app-rglogo::ng-deep {\n            img {\n                display: block;\n            }\n        }\n    }\n}\n\n.navbar__time-section {\n    height: 1.188rem;\n    margin: 2px 1rem;\n    margin-left: max(1.5rem, env(safe-area-inset-left));\n    margin-right: max(1.5rem, env(safe-area-inset-right));\n    display: flex;\n    display: flex;\n    align-items: center;\n}\n\nnavbar-state-selector {\n    margin-left: auto;\n}\n\nion-menu-button {\n    height: 100%;\n\n    &:has(ion-icon[name*='menu-sharp']) {\n        margin-top: 0.25rem;\n        --padding-start: 0;\n        --padding-end: 0;\n        width: 1.5rem;\n    }\n\n    &:has(ion-icon[name*='person-outline']) {\n        width: 2.5rem;\n        height: 2.5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 2px solid var(--ion-color-secondary);\n        border-radius: 50%;\n    }\n\n    --background-hover-opacity: 0;\n}\n\nion-icon[name*='menu-sharp'] {\n    font-size: 1.5rem;\n}\n\nion-icon[name*='person-outline'] {\n    font-size: 1.25rem;\n}\n\n.header-md::after,\n.header-ios::after {\n    content: \"\";\n    height: 0;\n}\n\n@media screen and (max-width: 768px) {\n    .navbar {\n        &__start-section {\n            flex: 1;\n            justify-content: flex-start;\n        }\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .navbar {\n        height: 2.75rem;\n\n        &__start-section {\n            margin-left: 0.5rem;\n            gap: 0.5rem;\n        }\n\n        &__end-section {\n            gap: 0.5rem;\n            margin: 0 .5rem 0 0;\n\n            &:has(app-navbar-deposit) {\n                margin-bottom: 0.25rem;\n            }\n\n            app-rglogo::ng-deep {\n                img {\n                    width: 2rem;\n                    height: 2rem;\n                }\n            }\n\n            app-navbar-deposit::ng-deep {\n                ion-button {\n                    margin: 0;\n                    height: 2rem;\n                    min-height: 2rem;\n                }\n            }\n        }\n\n        ion-menu-button {\n            &:has(ion-icon[name*='person-outline']) {\n                width: 2.5rem;\n            }\n        }\n    }\n\n    .navbar__time-section {\n        pre {\n            margin: 2px 0.5rem;\n            margin-left: max(0.5rem, env(safe-area-inset-left));\n        }\n    }\n}\n\n@media screen and (max-width: 400px) {\n    .navbar {\n        &--cobrand {\n            .navbar__start-section {\n                gap: 0.25rem;\n            }\n\n            .navbar__end-section {\n                gap: 0.25rem;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 370px) {\n    app-rglogo::ng-deep {\n        img {\n            width: 1.5rem;\n            height: 1.5rem;\n        }\n    }\n\n    ion-button[name*=navbar] {\n        width: 3.75rem;\n        font-size: 0.8rem;\n    }\n\n    .navbar {\n        ion-menu-button {\n            &:has(ion-icon[name*='custom-person']) {\n                width: 2rem;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 330px) {\n    .navbar {\n        ion-menu-button {\n            &:has(ion-icon[name*='custom-person']) {\n                width: 1.8rem;\n            }\n        }\n    }\n}\n\n.safe-area-left-padding {\n    padding-left: env(safe-area-inset-left);\n}\n\nion-icon[name=\"custom-person\"] {\n    font-size: 2.25rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
